import { Pages } from '.generated/Project.CW.model';
import type { WithContext, MedicalWebPage } from 'schema-dts';
import { stripHtmlTags } from 'lib/utils/string-utils';
import { MinimalSchemaItem } from './minimal-schema-item';

export const buildTreatmentPageJsonLd = (
  data: Pages.ConditionOrTreatment,
  pageUrl: string,
  relatedSpecialty: MinimalSchemaItem[]
): WithContext<MedicalWebPage> => {
  const specialty = relatedSpecialty?.[0];
  const mainEntity =
    !!specialty?.url.path && !!specialty?.name
      ? {
          '@type': 'Service' as const,
          '@id': specialty.url.path,
          name: specialty.name,
        }
      : undefined;
  const base = {
    '@context': 'https://schema.org' as const,
    '@type': 'MedicalWebPage' as const,
    name: data.fields?.Title?.value,
    description: stripHtmlTags(data.fields?.Description?.value),
    url: pageUrl,
    mainEntity,
    medicalAudience: { '@type': 'MedicalAudience' as const, audienceType: 'Patient' },
    '@id': pageUrl,
  };
  return mainEntity ? { ...base, mainEntity } : base;
};
